import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostErforderlichesDokumentCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostErforderlichesDokumentCommandService],
  exports: []
})
export class PostErforderlichesDokumentCommandServiceModule { }
